<template>
  <div class="cdr-recording-player">
    <template v-if="tieneArchivo">
      <div class="d-flex flex-column align-start">
        <v-btn
          small
          text
          color="primary"
          class="px-1"
          :loading="loading"
          :disabled="loading"
          @click="onEscuchar"
        >
          <v-icon left small>mdi-headphones</v-icon>
          {{ objectUrl ? 'Reproducir' : 'Escuchar' }}
        </v-btn>
        <audio
          v-if="objectUrl"
          ref="audioEl"
          :src="objectUrl"
          controls
          class="cdr-recording-player__audio mt-1"
          preload="metadata"
        />
        <span v-if="error" class="error--text text-caption mt-1">{{ error }}</span>
      </div>
    </template>
    <span v-else class="grey--text text-caption">—</span>
  </div>
</template>

<script>
import { recordfilesIndicaAudio, canonicalWavFilename, getRecordingObjectUrl } from '@/utils/telefoniaRecording'

export default {
  name: 'CdrRecordingPlayer',

  props: {
    recordfiles: {
      type: [String, Number],
      default: null
    },
    /** Nombre de carpeta en el servidor (ej. "Sucursal Centro") → …/audios/{sucursal}/{uniqueid}.wav */
    sucursal: {
      type: [String, Number],
      default: null
    },
    /** Uniqueid: nombre del fichero de audio (se añade .wav si falta) */
    uniqueid: {
      type: [String, Number],
      default: null
    }
  },

  data () {
    return {
      loading: false,
      objectUrl: null,
      error: ''
    }
  },

  computed: {
    /** recordfiles indica si hay grabación; el enlace usa sucursal + uniqueid */
    tieneArchivo () {
      return recordfilesIndicaAudio(this.recordfiles) && canonicalWavFilename(this.uniqueid) !== ''
    }
  },

  watch: {
    recordfiles () {
      this.error = ''
      this.revokeUrl()
    },
    sucursal () {
      this.error = ''
      this.revokeUrl()
    },
    uniqueid () {
      this.error = ''
      this.revokeUrl()
    }
  },

  beforeDestroy () {
    this.revokeUrl()
  },

  methods: {
    revokeUrl () {
      if (this.objectUrl && String(this.objectUrl).startsWith('blob:')) {
        URL.revokeObjectURL(this.objectUrl)
      }
      this.objectUrl = null
    },

    async onEscuchar () {
      this.error = ''
      if (!this.tieneArchivo) return
      if (this.objectUrl) {
        this.$nextTick(() => {
          const el = this.$refs.audioEl
          if (el && typeof el.play === 'function') {
            el.play().catch(() => {})
          }
        })
        return
      }
      this.loading = true
      try {
        const s = this.sucursal != null && this.sucursal !== ''
          ? this.sucursal
          : null
        this.objectUrl = await getRecordingObjectUrl(this.recordfiles, s, this.uniqueid)
      } catch (e) {
        this.error = (e && e.message) ? e.message : 'No se pudo cargar la grabación'
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.cdr-recording-player__audio {
  max-width: min(280px, 100%);
  height: 32px;
}
</style>
